import styled, { css } from 'styled-components';

import { Divider } from 'antd';
import { theme } from './theme';
import { mediaSize } from './media';



export const spinnerStyles = css`
  content: '';
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  animation: spinner .8s ease infinite;
`;

export const btnSpinner = css`
  ${spinnerStyles};
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  border: 2px solid transparent;
  border-top-color: ${theme.colors.white};
  border-bottom-color: ${theme.colors.white};
`;

export const tangerineGradient = css`
  background-image: linear-gradient(
    to left,
    ${theme.colors.tangerineSecond},
    ${theme.colors.tangerinePrimary}
  );
`;

export const tangerineGradientRevert = css`
  background-image: linear-gradient(
    to right,
    ${theme.colors.tangerineSecond},
    ${theme.colors.tangerinePrimary}
  );
`;

export const littleButton = css`
  text-align: center;
  border-radius: 12.7px;
  border: solid 1.1px ${theme.colors.borderSilver};
  padding: 0 10px;
  line-height: 20px;
  cursor: pointer;
  min-width: fit-content;
  background: none;
  outline: none;
`;

export const hideOverflowText = css`
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const cardCss = css`
  padding: 22px 24px;
  border-radius: 4px;
  background-color: ${props => props.theme.colors.white};
  border: 1px solid ${props => props.theme.colors.borderLightSilver};
  box-shadow: 0 2px 3px ${props => props.theme.colors.shadowSilver};
  
  @media (max-width: ${mediaSize.phone}) {
    padding: 11px 12px;
  }
`;

export const DividerS = styled(Divider)`  
  margin: 10px 0;
  background: ${props => props.theme.colors.borderSilverDark};
  opacity: 0.15;
`;



// WEBPACK FOOTER //
// ./src/styles/helpers.js